export * from "./create-user.component";
export * from "./create-user.module";


// WEBPACK FOOTER //
// ./src/app/admin/create-user/index.ts